<template>
    <div class="page" v-if="show">
        <div class="b2" v-if="!isEmpty(customerList)">
            <div class="address-data" v-for="(item, i) in customerList">
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">客户名称</p>
                    <span data-flex-box="1">{{ item.customerName }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">联系人</p>
                    <span data-flex-box="1">{{ item.contactName }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">产品名称</p>
                    <span data-flex-box="1">{{ item.productName }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">设备型号</p>
                    <span data-flex-box="1">{{ item.unitType }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">机身号码</p>
                    <span data-flex-box="1">{{ item.deviceNo }}</span>
                </div>
                <div data-flex="cross:center" class="address-info">
                    <p class="txt f-fwb">{{ item.fullAddress }}</p>
                </div>
                <div class="bth-box" data-flex="cross:center">
                    <div data-flex="cross:center" data-flex-box="1" @click="setDefault(item.id)">
                        <img v-if="item.isDefault == 1" class="icon" src="../../assets/images/icon_rdo02.png" alt="">
                        <img v-else class="icon" src="../../assets/images/icon_rdo01.png" alt="">
                        <span class="ml-20">默认地址</span>
                    </div>
                    <div>
                        <van-button class="s1" type="primary" @click="del(item.id)">删除</van-button>
                        <van-button class="s2" type="primary" @click="toUrl('/customer/add?id=' + item.id)">编辑
                        </van-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <van-empty description="暂无" />
        </div>
        <div class="btn">
            <van-button type="primary" @click="toUrl('/customer/add')">添加客户信息</van-button>
        </div>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Field, Dialog, Toast, Empty } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        [Dialog.name]: Dialog,
        [Empty.name]: Empty,
        [Button.name]: Button,
        [Field.name]: Field,
    },
    data() {
        return {
            show: false,
            customerList: [],
        }
    },
    methods: {
        async getCustomerList() {
            const promise = this.apiGet('my.customer.list')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            this.show = true
            if (this.isEmpty(apiResult)) {
                return
            }

            this.customerList = apiResult.list
            this.isDataLoaded = true
        },
        toUrl(url) {
            this.$router.push(url)
        },

        setDefault(id) {
            Dialog.confirm({
                // title: '删除',
                message:
                    '确定修改？',
            })
                .then(async () => {

                    const promise = this.apiPost('my.customer.default', { id })

                    let apiResult = null

                    try {
                        apiResult = await promise
                    } catch (ex) {
                        apiResult = null
                    }

                    if (this.isEmpty(apiResult) || apiResult.errno != 0) {
                        Toast(apiResult.error);
                        return
                    }

                    Toast('操作成功');
                    this.getCustomerList()
                })
                .catch(() => {
                    // on cancel
                });
        },
        del(id) {
            Dialog.confirm({
                // title: '删除',
                message:
                    '确定删除？',
            })
                .then(async () => {

                    const promise = this.apiDelete('my.customer.del', { id })

                    let apiResult = null

                    try {
                        apiResult = await promise
                    } catch (ex) {
                        apiResult = null
                    }

                    if (this.isEmpty(apiResult) || apiResult.errno != 0) {
                        Toast(apiResult.error);
                        return
                    }

                    Toast('操作成功');
                    this.getCustomerList()
                })
                .catch(() => {
                    // on cancel
                });
        }

    },
    mounted() {

    },
    created() {
        this.getCustomerList()
    }
}
</script>

<style lang="less" scoped>
.page {
    padding-bottom: 150px;


    .list {
        height: 120px;
        padding: 0 30px;
        box-sizing: border-box;
        border-bottom: solid 1px #F9F5F5;

        .tit {
            min-width: 150px;
        }

        .img {
            width: 76px;
            height: 76px;
        }

        p {
            font-size: 15px;
        }
    }


    .b2 {
        border-radius: 10px 10px 0 0;
        margin-top: 20px;


        .address-data {
            padding: 10px 30px;
            box-sizing: border-box;
            width: 690px;
            margin: 0 auto;
            background: #fff;
            margin-bottom: 20px;

            .item {
                padding: 9px 0;

                p {
                    width: 110px;
                    text-align: right;
                    font-size: 14px;
                    padding-right: 20px;
                }

                span {
                    font-size: 14px;
                    color: #376CFE;
                }
            }

            .address-info {

                padding: 20px 0px 30px;
                box-sizing: border-box;

                img {
                    width: 60px;
                    height: 60px;
                    margin-right: 20px;
                }

                .txt {
                    font-size: 14px;
                    color: #000;
                }
            }

            .bth-box {
                border-top: solid 1px #f1f1f1;
                padding: 30px 0;

                .icon {
                    width: 46px;
                    height: 46px;
                }

                .s1,
                .s2 {
                    width: 106px;
                    height: 50px;
                    border-radius: 100px;
                    // padding: 10rpx 0;
                    font-size: 14px;
                    margin-left: 20px;
                    text-align: center;
                    border: solid 1px #B5B5B5;
                    color: #B5B5B5;
                    white-space: nowrap;
                    background: #fff;
                }

                .s2 {
                    background: #D65E5E;
                    border: solid 1px #D65E5E;
                    color: #fff;
                }
            }
        }
    }

    .btn {
        position: fixed;
        bottom: 30px;
        left: 30px;
        text-align: center;
        margin-top: 65px;

        button {

            width: 690px;
            height: 80px;
            border-radius: 200px;
            background: #205CFF;
            border-color: #205CFF;
            margin: 0 auto;
        }
    }
}
</style>